import {
  Table,
  TableContainer,
  TableHead,
  TableHeaderCell,
  TableRow,
  TableBody,
} from "@softmax/design-system";
import type { ReactNode } from "react";

export function PolicyCollectionTable({
  layout,
  children,
}: {
  readonly layout: "page" | "workspace";
  readonly children: ReactNode;
}) {
  const tableHead = (
    <TableHead>
      <TableRow>
        <TableHeaderCell>Policy</TableHeaderCell>
        <TableHeaderCell>Owner</TableHeaderCell>
        <TableHeaderCell align="end">Versions</TableHeaderCell>
        <TableHeaderCell>Created</TableHeaderCell>
      </TableRow>
    </TableHead>
  );
  const columns =
    layout === "workspace" ? (
      <colgroup>
        <col width="45%" />
        <col width="25%" />
        <col width="12%" />
        <col width="18%" />
      </colgroup>
    ) : null;
  return (
    <TableContainer aria-label="Policies">
      <Table
        density="compact"
        layout={layout === "workspace" ? "fixed" : "auto"}
      >
        {columns}
        {tableHead}
        <TableBody>{children}</TableBody>
      </Table>
    </TableContainer>
  );
}
